import React from 'react';
import { graphql } from 'gatsby';

import GlobalLayout from '../components/common/Layout';

import AboutComponent from '../components/about';
import SeoHelmet from '../components/common/SeoHelmet';

const AboutTemplate = ({ data: { markdownRemark } }) => {
  const {
    fields: { slug: url },
    frontmatter: { missionHero, seo, whyChooseUs, features, poweredByUpgrade, contact, legal, notice }
  } = markdownRemark;

  return (
    <GlobalLayout {...{ legal, margin: false, notice }}>
      <SeoHelmet {...{ ...seo, url }} />
      <AboutComponent {...{ missionHero, whyChooseUs, features, poweredByUpgrade, contact }} />
    </GlobalLayout>
  );
};

export const pageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      fields {
        slug
      }
      frontmatter {
        seo {
          title
          description
          image
        }
        missionHero {
          title
          backgroundColor
          image
          missionTitle
          missionText
        }
        whyChooseUs {
          title
          subtitle
          highlights {
            title
            subtitle
          }
        }
        features {
          title
          subtitle
          infoTypes {
            columns
            items {
              title
              description
              image
            }
          }
        }
        poweredByUpgrade {
          description
          poweredByText
          image
        }
        contact {
          backgroundColor
          days
          hours
          mail
          phone
        }
        legal
        notice
      }
    }
  }
`;

export default AboutTemplate;
